// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FkXr","newExpiryDate":"styles_newExpiryDate__1L-sb","footer":"styles_footer__2kUgJ"};